import React from 'react'

import Container, { TContainerProps } from './Container'
import Row, { TRowProps } from './Row'
import Col, { TColProps } from './Col'

import { TComponentBase } from '../../types/componentBase'

type TGridComposition = {
  Container: React.FC<TContainerProps & TComponentBase>
  Row: React.FC<TRowProps & TComponentBase>
  Col: React.FC<TColProps & TComponentBase>
}

const Grid: React.FC & TGridComposition = () => null

Grid.Container = Container
Grid.Row = Row
Grid.Col = Col

export { Grid as default }
